import React from 'react';

import './WhyUsSection.sass';

import {connect} from 'react-redux';
import {fetchOrdersTotal} from '../../ducks/misc';

import Reviews from '../reviews/Reviews';
import FeatureText from '../featureText/FeatureText';
import Benefits from '../benefits/Benefits';

import {FormattedMessage} from 'react-intl';

import whyUsBg from './assets/bg_main_mid.jpg';
import whyUsBgWebp from './assets/bg_main_mid.webp';

@connect(({misc}) => ({ordersTotal: misc.ordersTotal}))
export default class WhyUsSection extends React.PureComponent {
  static fetchData = ({dispatch, ordersTotal}) => ordersTotal === undefined && dispatch(fetchOrdersTotal());

  componentDidMount() {
    WhyUsSection.fetchData(this.props);
  }

  componentDidUpdate() {
    WhyUsSection.fetchData(this.props);
  }

  render() {
    const {ordersTotal} = this.props;

    return (
      <div className="why-us">
        <div className="why-us__bg">
          <picture>
            <source srcSet={whyUsBgWebp} type="image/webp"/>
            <source srcSet={whyUsBg} type="image/jpeg"/>
            <img loading="lazy" src={whyUsBg} alt="Why us section background"/>
          </picture>
        </div>

        <section className="container">
          <FeatureText
            center
            subheader={<FormattedMessage id="section.why-us.subtitle"/>}
            header={<FormattedMessage id="section.why-us.title"/>}
            text={<FormattedMessage id="section.why-us.description"/>}
          />
        </section>

        <Reviews orderCount={ordersTotal}/>

        <Benefits/>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./components/whyUsSection/WhyUsSection.js